import { useSelector } from 'react-redux';

import { getCurrentWorkspaceId } from '@redux/selectors/workspaces.selectors';

export default (): number => {
  return useSelector(getCurrentWorkspaceId);
};
